import { put } from "redux-saga/effects";

import makeRequest from "rdx/utils/makeRequest";
import getErrorActions from "rdx/utils/getErrorActions";
import actions from "rdx/actions";
import messages from "rdx/modules/compensation/messages";
import { camelizeKeys } from "lib/helpers";

function* getLedger(action) {
  const params = action.payload;
  const { success, data, error } = yield* makeRequest.get("/compensation/ledger", params);

  if (success && data) {
    yield put(actions.setLedger(camelizeKeys(data.body)));
  } else if (error) {
    return getErrorActions({
      error,
      message: messages.ERROR_GETTING_LEDGER,
    });
  }

  return null;
}

export default getLedger;
